ArchivedListView = require 'views/archive/archived-list-view'
ModelLoader = require 'db/model-loader'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
l = require 'lib/localize'

module.exports = class ArchivedListsView extends View
  initialize: ({ @searchText }) ->
    @isLoading = @slot(true)
    @allArchivedLists = @slot([])

    @sortedFilteredLists = @allArchivedLists.combine(@searchText)
    .map ([lists, searchText]) ->
      if searchText == ''
        lists
      else
        isMatch = Util.buildFuzzyMatcher(searchText)
        _.filter lists, (list) -> isMatch list.get('name')
    .map (lists) ->
      _.sortBy lists, (list) -> list.get('name')

    @using @sortedFilteredLists

    @listenTo @modelCache, 'change:List:closed', (list) =>
      if list.get('closed')
        @allArchivedLists.set [list, @allArchivedLists.get()...]
      else
        @allArchivedLists.set _.without(@allArchivedLists.get(), list)

  # TODO: effing once
  hasBeenActiveBefore: false
  didBecomeActive: ->
    if @hasBeenActiveBefore
      return
    @hasBeenActiveBefore = true

    ModelLoader.loadArchivedLists(@model.id)
    .then (lists) =>
      archivedLists = @modelCache.find 'List', (list) =>
        list.get('idBoard') == @model.id && list.get('closed')
      @allArchivedLists.set archivedLists
      @isLoading.set false
    return

  vigor: @VIGOR.SOME
  renderOnce: ->
    @$el.html templates.fill 'archived_lists'

    @watch 'searchText', (searchText) ->
      key = if searchText.length == 0
        'no archived lists'
      else
        'no results'
      @$('.js-empty-message').text l(key)

    @watch 'sortedFilteredLists', (lists) ->
      @$('.js-empty-message').toggleClass 'hide', lists.length > 0

    @watch 'sortedFilteredLists', @frameDebounce @renderLists

  renderLists: ->
    @$('.js-archive-items').children().detach()

    itemSubviews = for list in @sortedFilteredLists.get()
      @subview ArchivedListView, list,
        reOpenText: l('unarchive list')
        canDelete: false

    @appendSubviews itemSubviews, @$('.js-archive-items')
    @



// WEBPACK FOOTER //
// ./app/scripts/views/archive/archived-lists-view.coffee